<template>
  <div class="app">
    <the-heading></the-heading>
    <div class="app-content">
      <left-menu></left-menu>
      <keep-alive exclude="WorkCounts">
        <router-view class="app-router-view"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import LeftMenu from './menus/left.vue'
import TheHeading from '@/components/base/TheHeading.vue'
export default {
  components: { LeftMenu, TheHeading },
  name: 'app',
  computed: {
    theme () {
      return this.$store.getters.theme
    }
  },
  watch: {
    theme: {
      immediate: true,
      handler (theme) {
        for (let theme of this.$store.getters.themeList) {
          document.body.classList.remove(theme.key + '-theme')
        }
        document.body.classList.add(theme + '-theme')
      }
    }
  }
}
</script>

<style lang="less">
@import '../../styles/theme.less';
body, html {height: 100%;}
.app-router-view {
  flex: 1;
  height: 100%;
  max-height: 100%;
}
.fm-title {
  background: rgba(0, 0, 0, 0) !important;
}
.app {
  background-color: @color-background-base;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.app-content {
  height: calc(100% - @the-heading-height);
  max-height: calc(100% - @the-heading-height);
  display: flex;
  align-items: flex-start;
  position: relative;
}

.white-theme {
    .app-router-view { background-color: @color-background-page-white; }
}
.dark-theme {
    .app-router-view { background-color: @color-background-page-dark; }
}
.pink-theme {
    &.app { background-color: #FFF; }
    .app-router-view { background-color: @color-background-page-pink; }
}
.pink-theme {
    &.app { background-color: #FFF; }
    .app-router-view { background-color: @color-background-page-blue; }
}
</style>
